import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[uiRadioWrapped]',
  standalone: true,
})
export class UiRadioWrappedDirective implements OnInit, OnChanges {
  @Input() uiRadioWrapped: boolean | '' = true;

  private static readonly WRAPPED_CLASS = 'ui-radio--wrapped';

  constructor(
    private hostElementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.applyWrappedClass();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['uiRadioWrapped']) {
      this.applyWrappedClass();
    }
  }

  private applyWrappedClass(): void {
    const hostElement = this.hostElementRef.nativeElement;
    const shouldWrap = this.coerceBooleanProperty(this.uiRadioWrapped);
    if (shouldWrap) {
      this.renderer.addClass(hostElement, UiRadioWrappedDirective.WRAPPED_CLASS);
    } else {
      this.renderer.removeClass(hostElement, UiRadioWrappedDirective.WRAPPED_CLASS);
    }
  }

  private coerceBooleanProperty(value: unknown): boolean {
    return value !== null && value !== undefined && `${value}` !== 'false';
  }
}
